import { applyMiddleware, createStore } from 'redux';
import rootReducer from './index'
import thunk from 'redux-thunk';

const store = createStore(rootReducer, applyMiddleware(thunk));
export type dispatchType = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;

export { store };
